export default "__VITE_ASSET__83ab4177__"